'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emotion = require('emotion');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NodeResolver = require('./NodeResolver');

var _NodeResolver2 = _interopRequireDefault(_NodeResolver);

var _index = require('./ScrollLock/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref

class ScrollBlock extends _react.PureComponent {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = { touchScrollTarget: null }, this.getScrollTarget = ref => {
      if (ref === this.state.touchScrollTarget) return;
      this.setState({ touchScrollTarget: ref });
    }, this.blurSelectInput = () => {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }, _temp;
  }

  // must be in state to trigger a re-render, only runs once per instance


  // this will close the menu when a user clicks outside


  render() {
    const { children, isEnabled } = this.props;
    const { touchScrollTarget } = this.state;

    // bail early if not enabled
    if (!isEnabled) return children;

    /*
     * Div
     * ------------------------------
     * blocks scrolling on non-body elements behind the menu
      * NodeResolver
     * ------------------------------
     * we need a reference to the scrollable element to "unlock" scroll on
     * mobile devices
      * ScrollLock
     * ------------------------------
     * actually does the scroll locking
     */
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('div', {
        onClick: this.blurSelectInput,
        className: (0, _emotion.css)({ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 })
      }),
      _react2.default.createElement(
        _NodeResolver2.default,
        { innerRef: this.getScrollTarget },
        children
      ),
      touchScrollTarget ? _react2.default.createElement(_index2.default, { touchScrollTarget: touchScrollTarget }) : null
    );
  }
}
exports.default = ScrollBlock;